import { newE2EPage } from '@stencil/core/testing';

describe('jackery-comment-overview', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-comment-overview></jackery-comment-overview>');

    const element = await page.find('jackery-comment-overview');
    expect(element).toHaveClass('hydrated');
  });
});
